import { useSideModalClose } from "../UI/Modals/SideModal";
import { Close } from "../../SVGS";
import { TiketDetailsSkeletonStyles } from "./tiketDetailsSkeleton.styles";

const TiketDetailsSkeleton = ({ closeModal }) => {
  const sideModalClose = useSideModalClose();
  const handleClose = sideModalClose || closeModal;

  return (
    <TiketDetailsSkeletonStyles>
      <div className="sk-card">
        <div className="sk-header">
          <div className="sk-header__title">
            <span className="sk-line sk-line--title" />
            <span className="sk-line sk-line--id" />
          </div>
          <div
            className="sk-header__close"
            onClick={handleClose}
            role="button"
            aria-label="Close"
          >
            <Close />
          </div>
        </div>

        <div className="sk-body">
          <div className="sk-block">
            <span className="sk-line sk-line--branch" />
            <span className="sk-line sk-line--address" />
          </div>

          <div className="sk-block">
            <div className="sk-map" />
          </div>

          <div className="sk-block">
            <div className="sk-grid-2">
              <div className="sk-field">
                <span className="sk-line sk-line--label" />
                <span className="sk-line sk-line--value" />
                <span className="sk-line sk-line--meta" />
              </div>
              <div className="sk-field">
                <span className="sk-line sk-line--label" />
                <span className="sk-pill" />
              </div>
            </div>
            <div className="sk-grid-2">
              <div className="sk-field">
                <span className="sk-line sk-line--label" />
                <span className="sk-line sk-line--value" />
                <span className="sk-line sk-line--meta" />
              </div>
              <div className="sk-field">
                <span className="sk-line sk-line--label" />
                <span className="sk-line sk-line--value" />
                <span className="sk-line sk-line--meta" />
              </div>
            </div>
            <div className="sk-card-row">
              <span className="sk-line sk-line--label" />
              <span className="sk-line sk-line--value" />
              <span className="sk-line sk-line--meta" />
            </div>
          </div>

          <div className="sk-block">
            <span className="sk-line sk-line--label" />
            <div className="sk-row-between">
              <div className="sk-col">
                <span className="sk-line sk-line--value" />
                <span className="sk-line sk-line--meta" />
              </div>
              <span className="sk-btn" />
            </div>
          </div>
        </div>

        <div className="sk-footer">
          <span className="sk-btn sk-btn--block" />
        </div>
      </div>
    </TiketDetailsSkeletonStyles>
  );
};

export default TiketDetailsSkeleton;
